"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _aciSantAntonio = _interopRequireDefault(require("./18_group_2023_03_15/aci-sant-antonio"));

var _acqualagna = _interopRequireDefault(require("./18_group_2023_03_15/acqualagna"));

var _acquasantaTerme = _interopRequireDefault(require("./18_group_2023_03_15/acquasanta-terme"));

var _adro = _interopRequireDefault(require("./18_group_2023_03_15/adro"));

var _ala = _interopRequireDefault(require("./18_group_2023_03_15/ala"));

var _albanella = _interopRequireDefault(require("./18_group_2023_03_15/albanella"));

var _albanoLaziale = _interopRequireDefault(require("./18_group_2023_03_15/albano-laziale"));

var _aldino = _interopRequireDefault(require("./18_group_2023_03_15/aldino"));

var _alleghe = _interopRequireDefault(require("./18_group_2023_03_15/alleghe"));

var _alseno = _interopRequireDefault(require("./18_group_2023_03_15/alseno"));

var _altaValTidone = _interopRequireDefault(require("./18_group_2023_03_15/alta-val-tidone"));

var _alzateBrianza = _interopRequireDefault(require("./18_group_2023_03_15/alzate-brianza"));

var _amelia = _interopRequireDefault(require("./18_group_2023_03_15/amelia"));

var _angoloTerme = _interopRequireDefault(require("./18_group_2023_03_15/angolo-terme"));

var _antrodoco = _interopRequireDefault(require("./18_group_2023_03_15/antrodoco"));

var _appianoSullaStradaDelVino = _interopRequireDefault(require("./18_group_2023_03_15/appiano-sulla-strada-del-vino"));

var _aprilia = _interopRequireDefault(require("./18_group_2023_03_15/aprilia"));

var _arce = _interopRequireDefault(require("./18_group_2023_03_15/arce"));

var _ardea = _interopRequireDefault(require("./18_group_2023_03_15/ardea"));

var _arquaPolesine = _interopRequireDefault(require("./18_group_2023_03_15/arqua-polesine"));

var _ascrea = _interopRequireDefault(require("./18_group_2023_03_15/ascrea"));

var _ausonia = _interopRequireDefault(require("./18_group_2023_03_15/ausonia"));

var _bagnaraCalabra = _interopRequireDefault(require("./18_group_2023_03_15/bagnara-calabra"));

var _bagnoregio = _interopRequireDefault(require("./18_group_2023_03_15/bagnoregio"));

var _barberinoDiMugello = _interopRequireDefault(require("./18_group_2023_03_15/barberino-di-mugello"));

var _barete = _interopRequireDefault(require("./18_group_2023_03_15/barete"));

var _belforteMonferrato = _interopRequireDefault(require("./18_group_2023_03_15/belforte-monferrato"));

var _bentivoglio = _interopRequireDefault(require("./18_group_2023_03_15/bentivoglio"));

var _bettola = _interopRequireDefault(require("./18_group_2023_03_15/bettola"));

var _beverino = _interopRequireDefault(require("./18_group_2023_03_15/beverino"));

var _boissano = _interopRequireDefault(require("./18_group_2023_03_15/boissano"));

var _bolzanoVicentino = _interopRequireDefault(require("./18_group_2023_03_15/bolzano-vicentino"));

var _bondeno = _interopRequireDefault(require("./18_group_2023_03_15/bondeno"));

var _bore = _interopRequireDefault(require("./18_group_2023_03_15/bore"));

var _borghi = _interopRequireDefault(require("./18_group_2023_03_15/borghi"));

var _borgoValbelluna = _interopRequireDefault(require("./18_group_2023_03_15/borgo-valbelluna"));

var _borgorose = _interopRequireDefault(require("./18_group_2023_03_15/borgorose"));

var _bredaDiPiave = _interopRequireDefault(require("./18_group_2023_03_15/breda-di-piave"));

var _brescello = _interopRequireDefault(require("./18_group_2023_03_15/brescello"));

var _bucciano = _interopRequireDefault(require("./18_group_2023_03_15/bucciano"));

var _buja = _interopRequireDefault(require("./18_group_2023_03_15/buja"));

var _buonvicino = _interopRequireDefault(require("./18_group_2023_03_15/buonvicino"));

var _buti = _interopRequireDefault(require("./18_group_2023_03_15/buti"));

var _cadelboscoDiSopra = _interopRequireDefault(require("./18_group_2023_03_15/cadelbosco-di-sopra"));

var _cairoMontenotte = _interopRequireDefault(require("./18_group_2023_03_15/cairo-montenotte"));

var _caivano = _interopRequireDefault(require("./18_group_2023_03_15/caivano"));

var _calviDellUmbria = _interopRequireDefault(require("./18_group_2023_03_15/calvi-dell-umbria"));

var _camino = _interopRequireDefault(require("./18_group_2023_03_15/camino"));

var _campiBisenzio = _interopRequireDefault(require("./18_group_2023_03_15/campi-bisenzio"));

var _camposanto = _interopRequireDefault(require("./18_group_2023_03_15/camposanto"));

var _cantagallo = _interopRequireDefault(require("./18_group_2023_03_15/cantagallo"));

var _cantiano = _interopRequireDefault(require("./18_group_2023_03_15/cantiano"));

var _capalbio = _interopRequireDefault(require("./18_group_2023_03_15/capalbio"));

var _capoDOrlando = _interopRequireDefault(require("./18_group_2023_03_15/capo-d-orlando"));

var _capodimonte = _interopRequireDefault(require("./18_group_2023_03_15/capodimonte"));

var _carinola = _interopRequireDefault(require("./18_group_2023_03_15/carinola"));

var _carlino = _interopRequireDefault(require("./18_group_2023_03_15/carlino"));

var _carovigno = _interopRequireDefault(require("./18_group_2023_03_15/carovigno"));

var _cartosio = _interopRequireDefault(require("./18_group_2023_03_15/cartosio"));

var _casalVelino = _interopRequireDefault(require("./18_group_2023_03_15/casal-velino"));

var _caselleLandi = _interopRequireDefault(require("./18_group_2023_03_15/caselle-landi"));

var _cassola = _interopRequireDefault(require("./18_group_2023_03_15/cassola"));

var _castagnetoCarducci = _interopRequireDefault(require("./18_group_2023_03_15/castagneto-carducci"));

var _castelCampagnano = _interopRequireDefault(require("./18_group_2023_03_15/castel-campagnano"));

var _castelSanPietroTerme = _interopRequireDefault(require("./18_group_2023_03_15/castel-san-pietro-terme"));

var _castelbelloCiardes = _interopRequireDefault(require("./18_group_2023_03_15/castelbello-ciardes"));

var _castelcivita = _interopRequireDefault(require("./18_group_2023_03_15/castelcivita"));

var _castelfranci = _interopRequireDefault(require("./18_group_2023_03_15/castelfranci"));

var _castelleoneDiSuasa = _interopRequireDefault(require("./18_group_2023_03_15/castelleone-di-suasa"));

var _castellettoDOrba = _interopRequireDefault(require("./18_group_2023_03_15/castelletto-d-orba"));

var _castelnovoBariano = _interopRequireDefault(require("./18_group_2023_03_15/castelnovo-bariano"));

var _castelnovoDelFriuli = _interopRequireDefault(require("./18_group_2023_03_15/castelnovo-del-friuli"));

var _castelsantangeloSulNera = _interopRequireDefault(require("./18_group_2023_03_15/castelsantangelo-sul-nera"));

var _castelvetroDiModena = _interopRequireDefault(require("./18_group_2023_03_15/castelvetro-di-modena"));

var _castenaso = _interopRequireDefault(require("./18_group_2023_03_15/castenaso"));

var _castilenti = _interopRequireDefault(require("./18_group_2023_03_15/castilenti"));

var _cavasoDelTomba = _interopRequireDefault(require("./18_group_2023_03_15/cavaso-del-tomba"));

var _cavassoNuovo = _interopRequireDefault(require("./18_group_2023_03_15/cavasso-nuovo"));

var _cavezzo = _interopRequireDefault(require("./18_group_2023_03_15/cavezzo"));

var _cermignano = _interopRequireDefault(require("./18_group_2023_03_15/cermignano"));

var _cerveteri = _interopRequireDefault(require("./18_group_2023_03_15/cerveteri"));

var _cerzeto = _interopRequireDefault(require("./18_group_2023_03_15/cerzeto"));

var _cetona = _interopRequireDefault(require("./18_group_2023_03_15/cetona"));

var _chianni = _interopRequireDefault(require("./18_group_2023_03_15/chianni"));

var _chions = _interopRequireDefault(require("./18_group_2023_03_15/chions"));

var _chiusi = _interopRequireDefault(require("./18_group_2023_03_15/chiusi"));

var _cipressa = _interopRequireDefault(require("./18_group_2023_03_15/cipressa"));

var _civitellaPaganico = _interopRequireDefault(require("./18_group_2023_03_15/civitella-paganico"));

var _codigoro = _interopRequireDefault(require("./18_group_2023_03_15/codigoro"));

var _colledara = _interopRequireDefault(require("./18_group_2023_03_15/colledara"));

var _colverde = _interopRequireDefault(require("./18_group_2023_03_15/colverde"));

var _condofuri = _interopRequireDefault(require("./18_group_2023_03_15/condofuri"));

var _configni = _interopRequireDefault(require("./18_group_2023_03_15/configni"));

var _coregliaAntelminelli = _interopRequireDefault(require("./18_group_2023_03_15/coreglia-antelminelli"));

var _coriano = _interopRequireDefault(require("./18_group_2023_03_15/coriano"));

var _cortona = _interopRequireDefault(require("./18_group_2023_03_15/cortona"));

var _cosenza = _interopRequireDefault(require("./18_group_2023_03_15/cosenza"));

var _costiglioleDAsti = _interopRequireDefault(require("./18_group_2023_03_15/costigliole-d-asti"));

var _crocettaDelMontello = _interopRequireDefault(require("./18_group_2023_03_15/crocetta-del-montello"));

var _cutro = _interopRequireDefault(require("./18_group_2023_03_15/cutro"));

var _dosolo = _interopRequireDefault(require("./18_group_2023_03_15/dosolo"));

var _dro = _interopRequireDefault(require("./18_group_2023_03_15/dro"));

var _ertoECasso = _interopRequireDefault(require("./18_group_2023_03_15/erto-e-casso"));

var _esperia = _interopRequireDefault(require("./18_group_2023_03_15/esperia"));

var _felino = _interopRequireDefault(require("./18_group_2023_03_15/felino"));

var _fiscaglia = _interopRequireDefault(require("./18_group_2023_03_15/fiscaglia"));

var _fiumicino = _interopRequireDefault(require("./18_group_2023_03_15/fiumicino"));

var _follo = _interopRequireDefault(require("./18_group_2023_03_15/follo"));

var _fontaniva = _interopRequireDefault(require("./18_group_2023_03_15/fontaniva"));

var _fontechiari = _interopRequireDefault(require("./18_group_2023_03_15/fontechiari"));

var _foppolo = _interopRequireDefault(require("./18_group_2023_03_15/foppolo"));

var _forlimpopoli = _interopRequireDefault(require("./18_group_2023_03_15/forlimpopoli"));

var _formello = _interopRequireDefault(require("./18_group_2023_03_15/formello"));

var _fornovoDiTaro = _interopRequireDefault(require("./18_group_2023_03_15/fornovo-di-taro"));

var _frattaTodina = _interopRequireDefault(require("./18_group_2023_03_15/fratta-todina"));

var _frisanco = _interopRequireDefault(require("./18_group_2023_03_15/frisanco"));

var _furciSiculo = _interopRequireDefault(require("./18_group_2023_03_15/furci-siculo"));

var _galluccio = _interopRequireDefault(require("./18_group_2023_03_15/galluccio"));

var _gerace = _interopRequireDefault(require("./18_group_2023_03_15/gerace"));

var _ghiffa = _interopRequireDefault(require("./18_group_2023_03_15/ghiffa"));

var _gianoDellUmbria = _interopRequireDefault(require("./18_group_2023_03_15/giano-dell-umbria"));

var _giffoniVallePiana = _interopRequireDefault(require("./18_group_2023_03_15/giffoni-valle-piana"));

var _gioiaSannitica = _interopRequireDefault(require("./18_group_2023_03_15/gioia-sannitica"));

var _gissi = _interopRequireDefault(require("./18_group_2023_03_15/gissi"));

var _gizzeria = _interopRequireDefault(require("./18_group_2023_03_15/gizzeria"));

var _godiascoSaliceTerme = _interopRequireDefault(require("./18_group_2023_03_15/godiasco-salice-terme"));

var _gragnanoTrebbiense = _interopRequireDefault(require("./18_group_2023_03_15/gragnano-trebbiense"));

var _grezzana = _interopRequireDefault(require("./18_group_2023_03_15/grezzana"));

var _grotteria = _interopRequireDefault(require("./18_group_2023_03_15/grotteria"));

var _guardea = _interopRequireDefault(require("./18_group_2023_03_15/guardea"));

var _guardiaLombardi = _interopRequireDefault(require("./18_group_2023_03_15/guardia-lombardi"));

var _joppolo = _interopRequireDefault(require("./18_group_2023_03_15/joppolo"));

var _langhirano = _interopRequireDefault(require("./18_group_2023_03_15/langhirano"));

var _laureanaCilento = _interopRequireDefault(require("./18_group_2023_03_15/laureana-cilento"));

var _lesignanoDeBagni = _interopRequireDefault(require("./18_group_2023_03_15/lesignano-de-bagni"));

var _liscianoNiccone = _interopRequireDefault(require("./18_group_2023_03_15/lisciano-niccone"));

var _longarone = _interopRequireDefault(require("./18_group_2023_03_15/longarone"));

var _lucoli = _interopRequireDefault(require("./18_group_2023_03_15/lucoli"));

var _lustra = _interopRequireDefault(require("./18_group_2023_03_15/lustra"));

var _maltignano = _interopRequireDefault(require("./18_group_2023_03_15/maltignano"));

var _marzabotto = _interopRequireDefault(require("./18_group_2023_03_15/marzabotto"));

var _marzanoAppio = _interopRequireDefault(require("./18_group_2023_03_15/marzano-appio"));

var _medesano = _interopRequireDefault(require("./18_group_2023_03_15/medesano"));

var _medolla = _interopRequireDefault(require("./18_group_2023_03_15/medolla"));

var _melitoDiPortoSalvo = _interopRequireDefault(require("./18_group_2023_03_15/melito-di-porto-salvo"));

var _mendicino = _interopRequireDefault(require("./18_group_2023_03_15/mendicino"));

var _merlino = _interopRequireDefault(require("./18_group_2023_03_15/merlino"));

var _mirabellaEclano = _interopRequireDefault(require("./18_group_2023_03_15/mirabella-eclano"));

var _modica = _interopRequireDefault(require("./18_group_2023_03_15/modica"));

var _moggioUdinese = _interopRequireDefault(require("./18_group_2023_03_15/moggio-udinese"));

var _molazzana = _interopRequireDefault(require("./18_group_2023_03_15/molazzana"));

var _monsampoloDelTronto = _interopRequireDefault(require("./18_group_2023_03_15/monsampolo-del-tronto"));

var _montaione = _interopRequireDefault(require("./18_group_2023_03_15/montaione"));

var _montalcino = _interopRequireDefault(require("./18_group_2023_03_15/montalcino"));

var _montanasoLombardo = _interopRequireDefault(require("./18_group_2023_03_15/montanaso-lombardo"));

var _monteSanMartino = _interopRequireDefault(require("./18_group_2023_03_15/monte-san-martino"));

var _montecchioEmilia = _interopRequireDefault(require("./18_group_2023_03_15/montecchio-emilia"));

var _montefalco = _interopRequireDefault(require("./18_group_2023_03_15/montefalco"));

var _montefioreDellAso = _interopRequireDefault(require("./18_group_2023_03_15/montefiore-dell-aso"));

var _montefranco = _interopRequireDefault(require("./18_group_2023_03_15/montefranco"));

var _montegiorgio = _interopRequireDefault(require("./18_group_2023_03_15/montegiorgio"));

var _montenars = _interopRequireDefault(require("./18_group_2023_03_15/montenars"));

var _montepulciano = _interopRequireDefault(require("./18_group_2023_03_15/montepulciano"));

var _monterenzio = _interopRequireDefault(require("./18_group_2023_03_15/monterenzio"));

var _montescudaio = _interopRequireDefault(require("./18_group_2023_03_15/montescudaio"));

var _montescudoMonteColombo = _interopRequireDefault(require("./18_group_2023_03_15/montescudo-monte-colombo"));

var _montevarchi = _interopRequireDefault(require("./18_group_2023_03_15/montevarchi"));

var _monteviale = _interopRequireDefault(require("./18_group_2023_03_15/monteviale"));

var _montorioAlVomano = _interopRequireDefault(require("./18_group_2023_03_15/montorio-al-vomano"));

var _morolo = _interopRequireDefault(require("./18_group_2023_03_15/morolo"));

var _morroReatino = _interopRequireDefault(require("./18_group_2023_03_15/morro-reatino"));

var _morsanoAlTagliamento = _interopRequireDefault(require("./18_group_2023_03_15/morsano-al-tagliamento"));

var _nanto = _interopRequireDefault(require("./18_group_2023_03_15/nanto"));

var _narni = _interopRequireDefault(require("./18_group_2023_03_15/narni"));

var _noceto = _interopRequireDefault(require("./18_group_2023_03_15/noceto"));

var _novafeltria = _interopRequireDefault(require("./18_group_2023_03_15/novafeltria"));

var _ocre = _interopRequireDefault(require("./18_group_2023_03_15/ocre"));

var _orgiano = _interopRequireDefault(require("./18_group_2023_03_15/orgiano"));

var _orria = _interopRequireDefault(require("./18_group_2023_03_15/orria"));

var _ortignanoRaggiolo = _interopRequireDefault(require("./18_group_2023_03_15/ortignano-raggiolo"));

var _osimo = _interopRequireDefault(require("./18_group_2023_03_15/osimo"));

var _ostiglia = _interopRequireDefault(require("./18_group_2023_03_15/ostiglia"));

var _ostra = _interopRequireDefault(require("./18_group_2023_03_15/ostra"));

var _paceDelMela = _interopRequireDefault(require("./18_group_2023_03_15/pace-del-mela"));

var _palagiano = _interopRequireDefault(require("./18_group_2023_03_15/palagiano"));

var _palena = _interopRequireDefault(require("./18_group_2023_03_15/palena"));

var _parghelia = _interopRequireDefault(require("./18_group_2023_03_15/parghelia"));

var _pastena = _interopRequireDefault(require("./18_group_2023_03_15/pastena"));

var _patrica = _interopRequireDefault(require("./18_group_2023_03_15/patrica"));

var _pederobba = _interopRequireDefault(require("./18_group_2023_03_15/pederobba"));

var _pellegrinoParmense = _interopRequireDefault(require("./18_group_2023_03_15/pellegrino-parmense"));

var _pellezzano = _interopRequireDefault(require("./18_group_2023_03_15/pellezzano"));

var _pernumia = _interopRequireDefault(require("./18_group_2023_03_15/pernumia"));

var _perticaAlta = _interopRequireDefault(require("./18_group_2023_03_15/pertica-alta"));

var _pescaglia = _interopRequireDefault(require("./18_group_2023_03_15/pescaglia"));

var _pescosansonesco = _interopRequireDefault(require("./18_group_2023_03_15/pescosansonesco"));

var _pezzaze = _interopRequireDefault(require("./18_group_2023_03_15/pezzaze"));

var _piancastagnaio = _interopRequireDefault(require("./18_group_2023_03_15/piancastagnaio"));

var _piandimeleto = _interopRequireDefault(require("./18_group_2023_03_15/piandimeleto"));

var _pianelloValTidone = _interopRequireDefault(require("./18_group_2023_03_15/pianello-val-tidone"));

var _picciano = _interopRequireDefault(require("./18_group_2023_03_15/picciano"));

var _pico = _interopRequireDefault(require("./18_group_2023_03_15/pico"));

var _pietradefusi = _interopRequireDefault(require("./18_group_2023_03_15/pietradefusi"));

var _pincara = _interopRequireDefault(require("./18_group_2023_03_15/pincara"));

var _piozzano = _interopRequireDefault(require("./18_group_2023_03_15/piozzano"));

var _platania = _interopRequireDefault(require("./18_group_2023_03_15/platania"));

var _poggioCatino = _interopRequireDefault(require("./18_group_2023_03_15/poggio-catino"));

var _poggioRenatico = _interopRequireDefault(require("./18_group_2023_03_15/poggio-renatico"));

var _poggioTorriana = _interopRequireDefault(require("./18_group_2023_03_15/poggio-torriana"));

var _posta = _interopRequireDefault(require("./18_group_2023_03_15/posta"));

var _prataDiPordenone = _interopRequireDefault(require("./18_group_2023_03_15/prata-di-pordenone"));

var _pratovecchioStia = _interopRequireDefault(require("./18_group_2023_03_15/pratovecchio-stia"));

var _provaglioDIseo = _interopRequireDefault(require("./18_group_2023_03_15/provaglio-d-iseo"));

var _quarrata = _interopRequireDefault(require("./18_group_2023_03_15/quarrata"));

var _rapagnano = _interopRequireDefault(require("./18_group_2023_03_15/rapagnano"));

var _resana = _interopRequireDefault(require("./18_group_2023_03_15/resana"));

var _rignanoFlaminio = _interopRequireDefault(require("./18_group_2023_03_15/rignano-flaminio"));

var _rignanoSullArno = _interopRequireDefault(require("./18_group_2023_03_15/rignano-sull-arno"));

var _riolunato = _interopRequireDefault(require("./18_group_2023_03_15/riolunato"));

var _rivodutri = _interopRequireDefault(require("./18_group_2023_03_15/rivodutri"));

var _roccaDiMezzo = _interopRequireDefault(require("./18_group_2023_03_15/rocca-di-mezzo"));

var _roccaSinibalda = _interopRequireDefault(require("./18_group_2023_03_15/rocca-sinibalda"));

var _roccadaspide = _interopRequireDefault(require("./18_group_2023_03_15/roccadaspide"));

var _roccamonfina = _interopRequireDefault(require("./18_group_2023_03_15/roccamonfina"));

var _roccapiemonte = _interopRequireDefault(require("./18_group_2023_03_15/roccapiemonte"));

var _roccasecca = _interopRequireDefault(require("./18_group_2023_03_15/roccasecca"));

var _rocchettaECroce = _interopRequireDefault(require("./18_group_2023_03_15/rocchetta-e-croce"));

var _ronchiDeiLegionari = _interopRequireDefault(require("./18_group_2023_03_15/ronchi-dei-legionari"));

var _ronciglione = _interopRequireDefault(require("./18_group_2023_03_15/ronciglione"));

var _roncoAllAdige = _interopRequireDefault(require("./18_group_2023_03_15/ronco-all-adige"));

var _roncofreddo = _interopRequireDefault(require("./18_group_2023_03_15/roncofreddo"));

var _rotella = _interopRequireDefault(require("./18_group_2023_03_15/rotella"));

var _rubiera = _interopRequireDefault(require("./18_group_2023_03_15/rubiera"));

var _rumo = _interopRequireDefault(require("./18_group_2023_03_15/rumo"));

var _saccolongo = _interopRequireDefault(require("./18_group_2023_03_15/saccolongo"));

var _salgareda = _interopRequireDefault(require("./18_group_2023_03_15/salgareda"));

var _saludecio = _interopRequireDefault(require("./18_group_2023_03_15/saludecio"));

var _salvitelle = _interopRequireDefault(require("./18_group_2023_03_15/salvitelle"));

var _sanDorligoDellaValle = _interopRequireDefault(require("./18_group_2023_03_15/san-dorligo-della-valle"));

var _sanFilippoDelMela = _interopRequireDefault(require("./18_group_2023_03_15/san-filippo-del-mela"));

var _sanGiacomoFilippo = _interopRequireDefault(require("./18_group_2023_03_15/san-giacomo-filippo"));

var _sanGiulianoTerme = _interopRequireDefault(require("./18_group_2023_03_15/san-giuliano-terme"));

var _sanLeonardo = _interopRequireDefault(require("./18_group_2023_03_15/san-leonardo"));

var _sanLorenzoDiSebato = _interopRequireDefault(require("./18_group_2023_03_15/san-lorenzo-di-sebato"));

var _sanLorenzoDorsino = _interopRequireDefault(require("./18_group_2023_03_15/san-lorenzo-dorsino"));

var _sanMartinoDiVenezze = _interopRequireDefault(require("./18_group_2023_03_15/san-martino-di-venezze"));

var _sanQuirino = _interopRequireDefault(require("./18_group_2023_03_15/san-quirino"));

var _sanVenanzo = _interopRequireDefault(require("./18_group_2023_03_15/san-venanzo"));

var _sanVitoChietino = _interopRequireDefault(require("./18_group_2023_03_15/san-vito-chietino"));

var _santaMariaDiSala = _interopRequireDefault(require("./18_group_2023_03_15/santa-maria-di-sala"));

var _santoStefanoRoero = _interopRequireDefault(require("./18_group_2023_03_15/santo-stefano-roero"));

var _satriano = _interopRequireDefault(require("./18_group_2023_03_15/satriano"));

var _savignanoIrpino = _interopRequireDefault(require("./18_group_2023_03_15/savignano-irpino"));

var _scalettaZanclea = _interopRequireDefault(require("./18_group_2023_03_15/scaletta-zanclea"));

var _scapoli = _interopRequireDefault(require("./18_group_2023_03_15/scapoli"));

var _scheggiaEPascelupo = _interopRequireDefault(require("./18_group_2023_03_15/scheggia-e-pascelupo"));

var _selliaMarina = _interopRequireDefault(require("./18_group_2023_03_15/sellia-marina"));

var _sessaCilento = _interopRequireDefault(require("./18_group_2023_03_15/sessa-cilento"));

var _sestaGodano = _interopRequireDefault(require("./18_group_2023_03_15/sesta-godano"));

var _sestoAlReghena = _interopRequireDefault(require("./18_group_2023_03_15/sesto-al-reghena"));

var _sestoCampano = _interopRequireDefault(require("./18_group_2023_03_15/sesto-campano"));

var _sissaTrecasali = _interopRequireDefault(require("./18_group_2023_03_15/sissa-trecasali"));

var _soliera = _interopRequireDefault(require("./18_group_2023_03_15/soliera"));

var _solignano = _interopRequireDefault(require("./18_group_2023_03_15/solignano"));

var _sorboSanBasile = _interopRequireDefault(require("./18_group_2023_03_15/sorbo-san-basile"));

var _spilamberto = _interopRequireDefault(require("./18_group_2023_03_15/spilamberto"));

var _spilimbergo = _interopRequireDefault(require("./18_group_2023_03_15/spilimbergo"));

var _staletti = _interopRequireDefault(require("./18_group_2023_03_15/staletti"));

var _stazzema = _interopRequireDefault(require("./18_group_2023_03_15/stazzema"));

var _supino = _interopRequireDefault(require("./18_group_2023_03_15/supino"));

var _suvereto = _interopRequireDefault(require("./18_group_2023_03_15/suvereto"));

var _taglioDiPo = _interopRequireDefault(require("./18_group_2023_03_15/taglio-di-po"));

var _tavazzanoConVillavesco = _interopRequireDefault(require("./18_group_2023_03_15/tavazzano-con-villavesco"));

var _tavullia = _interopRequireDefault(require("./18_group_2023_03_15/tavullia"));

var _teggiano = _interopRequireDefault(require("./18_group_2023_03_15/teggiano"));

var _tenno = _interopRequireDefault(require("./18_group_2023_03_15/tenno"));

var _terracina = _interopRequireDefault(require("./18_group_2023_03_15/terracina"));

var _terricciola = _interopRequireDefault(require("./18_group_2023_03_15/terricciola"));

var _tignale = _interopRequireDefault(require("./18_group_2023_03_15/tignale"));

var _torreDeBusi = _interopRequireDefault(require("./18_group_2023_03_15/torre-de-busi"));

var _torriInSabina = _interopRequireDefault(require("./18_group_2023_03_15/torri-in-sabina"));

var _torriglia = _interopRequireDefault(require("./18_group_2023_03_15/torriglia"));

var _tovoSanGiacomo = _interopRequireDefault(require("./18_group_2023_03_15/tovo-san-giacomo"));

var _travo = _interopRequireDefault(require("./18_group_2023_03_15/travo"));

var _tremosineSulGarda = _interopRequireDefault(require("./18_group_2023_03_15/tremosine-sul-garda"));

var _tuoroSulTrasimeno = _interopRequireDefault(require("./18_group_2023_03_15/tuoro-sul-trasimeno"));

var _ultimo = _interopRequireDefault(require("./18_group_2023_03_15/ultimo"));

var _urbe = _interopRequireDefault(require("./18_group_2023_03_15/urbe"));

var _valLiona = _interopRequireDefault(require("./18_group_2023_03_15/val-liona"));

var _valbrenta = _interopRequireDefault(require("./18_group_2023_03_15/valbrenta"));

var _valdaora = _interopRequireDefault(require("./18_group_2023_03_15/valdaora"));

var _valdidentro = _interopRequireDefault(require("./18_group_2023_03_15/valdidentro"));

var _valdisotto = _interopRequireDefault(require("./18_group_2023_03_15/valdisotto"));

var _valleDiMaddaloni = _interopRequireDefault(require("./18_group_2023_03_15/valle-di-maddaloni"));

var _valvarrone = _interopRequireDefault(require("./18_group_2023_03_15/valvarrone"));

var _varanoDeMelegari = _interopRequireDefault(require("./18_group_2023_03_15/varano-de-melegari"));

var _vareseLigure = _interopRequireDefault(require("./18_group_2023_03_15/varese-ligure"));

var _veglio = _interopRequireDefault(require("./18_group_2023_03_15/veglio"));

var _venarotta = _interopRequireDefault(require("./18_group_2023_03_15/venarotta"));

var _ventasso = _interopRequireDefault(require("./18_group_2023_03_15/ventasso"));

var _veroli = _interopRequireDefault(require("./18_group_2023_03_15/veroli"));

var _vetto = _interopRequireDefault(require("./18_group_2023_03_15/vetto"));

var _vigodarzere = _interopRequireDefault(require("./18_group_2023_03_15/vigodarzere"));

var _villaCollemandina = _interopRequireDefault(require("./18_group_2023_03_15/villa-collemandina"));

var _villaFaraldi = _interopRequireDefault(require("./18_group_2023_03_15/villa-faraldi"));

var _villafrancaPadovana = _interopRequireDefault(require("./18_group_2023_03_15/villafranca-padovana"));

var _villanovaDelSillaro = _interopRequireDefault(require("./18_group_2023_03_15/villanova-del-sillaro"));

var _villeDiFiemme = _interopRequireDefault(require("./18_group_2023_03_15/ville-di-fiemme"));

var _viterbo = _interopRequireDefault(require("./18_group_2023_03_15/viterbo"));

var _vo = _interopRequireDefault(require("./18_group_2023_03_15/vo"));

var _volpedo = _interopRequireDefault(require("./18_group_2023_03_15/volpedo"));

var _zeloBuonPersico = _interopRequireDefault(require("./18_group_2023_03_15/zelo-buon-persico"));

var _zubiena = _interopRequireDefault(require("./18_group_2023_03_15/zubiena"));

var _zumpano = _interopRequireDefault(require("./18_group_2023_03_15/zumpano"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _aciSantAntonio["default"], {}, _acqualagna["default"], {}, _acquasantaTerme["default"], {}, _adro["default"], {}, _ala["default"], {}, _albanella["default"], {}, _albanoLaziale["default"], {}, _aldino["default"], {}, _alleghe["default"], {}, _alseno["default"], {}, _altaValTidone["default"], {}, _alzateBrianza["default"], {}, _amelia["default"], {}, _angoloTerme["default"], {}, _antrodoco["default"], {}, _appianoSullaStradaDelVino["default"], {}, _aprilia["default"], {}, _arce["default"], {}, _ardea["default"], {}, _arquaPolesine["default"], {}, _ascrea["default"], {}, _ausonia["default"], {}, _bagnaraCalabra["default"], {}, _bagnoregio["default"], {}, _barberinoDiMugello["default"], {}, _barete["default"], {}, _belforteMonferrato["default"], {}, _bentivoglio["default"], {}, _bettola["default"], {}, _beverino["default"], {}, _boissano["default"], {}, _bolzanoVicentino["default"], {}, _bondeno["default"], {}, _bore["default"], {}, _borghi["default"], {}, _borgoValbelluna["default"], {}, _borgorose["default"], {}, _bredaDiPiave["default"], {}, _brescello["default"], {}, _bucciano["default"], {}, _buja["default"], {}, _buonvicino["default"], {}, _buti["default"], {}, _cadelboscoDiSopra["default"], {}, _cairoMontenotte["default"], {}, _caivano["default"], {}, _calviDellUmbria["default"], {}, _camino["default"], {}, _campiBisenzio["default"], {}, _camposanto["default"], {}, _cantagallo["default"], {}, _cantiano["default"], {}, _capalbio["default"], {}, _capoDOrlando["default"], {}, _capodimonte["default"], {}, _carinola["default"], {}, _carlino["default"], {}, _carovigno["default"], {}, _cartosio["default"], {}, _casalVelino["default"], {}, _caselleLandi["default"], {}, _cassola["default"], {}, _castagnetoCarducci["default"], {}, _castelCampagnano["default"], {}, _castelSanPietroTerme["default"], {}, _castelbelloCiardes["default"], {}, _castelcivita["default"], {}, _castelfranci["default"], {}, _castelleoneDiSuasa["default"], {}, _castellettoDOrba["default"], {}, _castelnovoBariano["default"], {}, _castelnovoDelFriuli["default"], {}, _castelsantangeloSulNera["default"], {}, _castelvetroDiModena["default"], {}, _castenaso["default"], {}, _castilenti["default"], {}, _cavasoDelTomba["default"], {}, _cavassoNuovo["default"], {}, _cavezzo["default"], {}, _cermignano["default"], {}, _cerveteri["default"], {}, _cerzeto["default"], {}, _cetona["default"], {}, _chianni["default"], {}, _chions["default"], {}, _chiusi["default"], {}, _cipressa["default"], {}, _civitellaPaganico["default"], {}, _codigoro["default"], {}, _colledara["default"], {}, _colverde["default"], {}, _condofuri["default"], {}, _configni["default"], {}, _coregliaAntelminelli["default"], {}, _coriano["default"], {}, _cortona["default"], {}, _cosenza["default"], {}, _costiglioleDAsti["default"], {}, _crocettaDelMontello["default"], {}, _cutro["default"], {}, _dosolo["default"], {}, _dro["default"], {}, _ertoECasso["default"], {}, _esperia["default"], {}, _felino["default"], {}, _fiscaglia["default"], {}, _fiumicino["default"], {}, _follo["default"], {}, _fontaniva["default"], {}, _fontechiari["default"], {}, _foppolo["default"], {}, _forlimpopoli["default"], {}, _formello["default"], {}, _fornovoDiTaro["default"], {}, _frattaTodina["default"], {}, _frisanco["default"], {}, _furciSiculo["default"], {}, _galluccio["default"], {}, _gerace["default"], {}, _ghiffa["default"], {}, _gianoDellUmbria["default"], {}, _giffoniVallePiana["default"], {}, _gioiaSannitica["default"], {}, _gissi["default"], {}, _gizzeria["default"], {}, _godiascoSaliceTerme["default"], {}, _gragnanoTrebbiense["default"], {}, _grezzana["default"], {}, _grotteria["default"], {}, _guardea["default"], {}, _guardiaLombardi["default"], {}, _joppolo["default"], {}, _langhirano["default"], {}, _laureanaCilento["default"], {}, _lesignanoDeBagni["default"], {}, _liscianoNiccone["default"], {}, _longarone["default"], {}, _lucoli["default"], {}, _lustra["default"], {}, _maltignano["default"], {}, _marzabotto["default"], {}, _marzanoAppio["default"], {}, _medesano["default"], {}, _medolla["default"], {}, _melitoDiPortoSalvo["default"], {}, _mendicino["default"], {}, _merlino["default"], {}, _mirabellaEclano["default"], {}, _modica["default"], {}, _moggioUdinese["default"], {}, _molazzana["default"], {}, _monsampoloDelTronto["default"], {}, _montaione["default"], {}, _montalcino["default"], {}, _montanasoLombardo["default"], {}, _monteSanMartino["default"], {}, _montecchioEmilia["default"], {}, _montefalco["default"], {}, _montefioreDellAso["default"], {}, _montefranco["default"], {}, _montegiorgio["default"], {}, _montenars["default"], {}, _montepulciano["default"], {}, _monterenzio["default"], {}, _montescudaio["default"], {}, _montescudoMonteColombo["default"], {}, _montevarchi["default"], {}, _monteviale["default"], {}, _montorioAlVomano["default"], {}, _morolo["default"], {}, _morroReatino["default"], {}, _morsanoAlTagliamento["default"], {}, _nanto["default"], {}, _narni["default"], {}, _noceto["default"], {}, _novafeltria["default"], {}, _ocre["default"], {}, _orgiano["default"], {}, _orria["default"], {}, _ortignanoRaggiolo["default"], {}, _osimo["default"], {}, _ostiglia["default"], {}, _ostra["default"], {}, _paceDelMela["default"], {}, _palagiano["default"], {}, _palena["default"], {}, _parghelia["default"], {}, _pastena["default"], {}, _patrica["default"], {}, _pederobba["default"], {}, _pellegrinoParmense["default"], {}, _pellezzano["default"], {}, _pernumia["default"], {}, _perticaAlta["default"], {}, _pescaglia["default"], {}, _pescosansonesco["default"], {}, _pezzaze["default"], {}, _piancastagnaio["default"], {}, _piandimeleto["default"], {}, _pianelloValTidone["default"], {}, _picciano["default"], {}, _pico["default"], {}, _pietradefusi["default"], {}, _pincara["default"], {}, _piozzano["default"], {}, _platania["default"], {}, _poggioCatino["default"], {}, _poggioRenatico["default"], {}, _poggioTorriana["default"], {}, _posta["default"], {}, _prataDiPordenone["default"], {}, _pratovecchioStia["default"], {}, _provaglioDIseo["default"], {}, _quarrata["default"], {}, _rapagnano["default"], {}, _resana["default"], {}, _rignanoFlaminio["default"], {}, _rignanoSullArno["default"], {}, _riolunato["default"], {}, _rivodutri["default"], {}, _roccaDiMezzo["default"], {}, _roccaSinibalda["default"], {}, _roccadaspide["default"], {}, _roccamonfina["default"], {}, _roccapiemonte["default"], {}, _roccasecca["default"], {}, _rocchettaECroce["default"], {}, _ronchiDeiLegionari["default"], {}, _ronciglione["default"], {}, _roncoAllAdige["default"], {}, _roncofreddo["default"], {}, _rotella["default"], {}, _rubiera["default"], {}, _rumo["default"], {}, _saccolongo["default"], {}, _salgareda["default"], {}, _saludecio["default"], {}, _salvitelle["default"], {}, _sanDorligoDellaValle["default"], {}, _sanFilippoDelMela["default"], {}, _sanGiacomoFilippo["default"], {}, _sanGiulianoTerme["default"], {}, _sanLeonardo["default"], {}, _sanLorenzoDiSebato["default"], {}, _sanLorenzoDorsino["default"], {}, _sanMartinoDiVenezze["default"], {}, _sanQuirino["default"], {}, _sanVenanzo["default"], {}, _sanVitoChietino["default"], {}, _santaMariaDiSala["default"], {}, _santoStefanoRoero["default"], {}, _satriano["default"], {}, _savignanoIrpino["default"], {}, _scalettaZanclea["default"], {}, _scapoli["default"], {}, _scheggiaEPascelupo["default"], {}, _selliaMarina["default"], {}, _sessaCilento["default"], {}, _sestaGodano["default"], {}, _sestoAlReghena["default"], {}, _sestoCampano["default"], {}, _sissaTrecasali["default"], {}, _soliera["default"], {}, _solignano["default"], {}, _sorboSanBasile["default"], {}, _spilamberto["default"], {}, _spilimbergo["default"], {}, _staletti["default"], {}, _stazzema["default"], {}, _supino["default"], {}, _suvereto["default"], {}, _taglioDiPo["default"], {}, _tavazzanoConVillavesco["default"], {}, _tavullia["default"], {}, _teggiano["default"], {}, _tenno["default"], {}, _terracina["default"], {}, _terricciola["default"], {}, _tignale["default"], {}, _torreDeBusi["default"], {}, _torriInSabina["default"], {}, _torriglia["default"], {}, _tovoSanGiacomo["default"], {}, _travo["default"], {}, _tremosineSulGarda["default"], {}, _tuoroSulTrasimeno["default"], {}, _ultimo["default"], {}, _urbe["default"], {}, _valLiona["default"], {}, _valbrenta["default"], {}, _valdaora["default"], {}, _valdidentro["default"], {}, _valdisotto["default"], {}, _valleDiMaddaloni["default"], {}, _valvarrone["default"], {}, _varanoDeMelegari["default"], {}, _vareseLigure["default"], {}, _veglio["default"], {}, _venarotta["default"], {}, _ventasso["default"], {}, _veroli["default"], {}, _vetto["default"], {}, _vigodarzere["default"], {}, _villaCollemandina["default"], {}, _villaFaraldi["default"], {}, _villafrancaPadovana["default"], {}, _villanovaDelSillaro["default"], {}, _villeDiFiemme["default"], {}, _viterbo["default"], {}, _vo["default"], {}, _volpedo["default"], {}, _zeloBuonPersico["default"], {}, _zubiena["default"], {}, _zumpano["default"]);

exports["default"] = _default;